import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import ViewModal from '../../../components/modals/viewModal';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter, statusTextFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules, FcViewDetails } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function JvReport(props) {

  const { isActive, isDebit, isOrder, type } = props;

  const { api, userData, settingData, refData, yearId, loadCustomerAccountOptions, customerAccountOptions,
    companyId, defaultCurrency, mainCurrency, allUserOptions, branchOptions, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);



  const table = 'jvReport';
  const title = 'Sales By Invoice';

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today, type, isActive, isDebit, isOrder });


  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['branch', 'user', 'customerAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }


  const statusOptions = [
    { value: ['Paid'], label: 'Paid' },
    { value: ['UnPaid'], label: 'UnPaid' },
    { value: ['SemiPaid'], label: 'SemiPaid' },
    { value: ['SemiPaid', 'UnPaid'], label: 'UnPaid and SemiPaid' },
  ]

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => ({
      ID: item.id,
      Date: item.date || item.createdAt || '',
      Type: item.type || '',
      Account: item.account?.english || '',

      Total: isUsingMainCurrency ? item.totalDebit : item.secondaryTotalDebit,
      Cost: isUsingMainCurrency ? item.cost : item.secondaryCost,
      Discount: isUsingMainCurrency ? item.discountAmount : item.secondaryDiscountAmount,
      Profit: isUsingMainCurrency ? item.profit : item.secondaryProfit,

      Status: statusFormatter ? statusFormatter(item.status) : item.status,
      RefNumber: item.refNumber || '',
      Details: item.details || '',
    }));

    return { transformedData };
  };


  const isUsingMainCurrency = useMemo(() => defaultCurrency.id === mainCurrency.id, [defaultCurrency.id, mainCurrency.id]);

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id', width: '8%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Date, dataIndex: 'date', width: '10%' },
    { title: contentLanguages.Type, dataIndex: 'type', width: '8%' },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.Total, dataIndex: isUsingMainCurrency ? 'totalDebit' : 'secondaryTotalDebit', width: '8%', render: numberFormatter },
    { title: contentLanguages.Cost, dataIndex: isUsingMainCurrency ? 'cost' : 'secondaryCost', width: '12%', render: numberFormatter },
    { title: contentLanguages.Discount, dataIndex: isUsingMainCurrency ? 'discountAmount' : 'secondaryDiscountAmount', width: '12%', render: numberFormatter },
    { title: contentLanguages.Profit, dataIndex: isUsingMainCurrency ? 'profit' : 'secondaryProfit', render: numberFormatter },
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
    {
      title: contentLanguages.View,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        </div>
      ),
    }
  ], []);


  const tableFooter = useMemo(() => [
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
      <Tag color={'#2c5d6f'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Total:  {numberFormatter(isUsingMainCurrency ? data?.summary?.balance : data?.summary?.secondaryBalance)}
        </div>
      </Tag>
      <Tag color={'#fe4e51'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Cost: {numberFormatter(isUsingMainCurrency ? data?.summary?.totalCost : data?.summary?.secondaryTotalCost)}
        </div>
      </Tag>
      <Tag color={'#388e3c'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          Profit: {numberFormatter(isUsingMainCurrency ? data?.summary?.balance - data?.summary?.totalCost :
            data?.summary?.secondaryBalance - data?.summary?.secondaryTotalCost)}
        </div>
      </Tag>
    </div>
  ]);

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }


  const selectedBranch = useMemo(
    () => branchOptions?.find(option => option.value === filter.branchId),
    [branchOptions, filter.branchId]
  );

  const selectedUser = useMemo(
    () => allUserOptions?.find(option => option.value === filter.createdBy),
    [allUserOptions, filter.createdBy]
  );

  const selectedCustomer = useMemo(
    () => customerAccountOptions?.find(option => option.value === filter.accountId),
    [customerAccountOptions, filter.accountId]
  );

  const selectedStatus = useMemo(
    () => statusOptions?.find(option => option.value === filter.status),
    [statusOptions, filter.accountId]
  );

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={4}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Branch...'}
                value={selectedBranch}
                onChange={(e) => handleSelectChange(e, 'branchId')}
              />
            </Col>


            <Col md={2}>
              <Select
                styles={selectStyles}
                options={allUserOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select User...'}
                value={selectedUser}
                onChange={(e) => handleSelectChange(e, 'createdBy')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadCustomerAccountOptions}
                isSearchable
                placeholder={'Select Customer...'}
                value={selectedCustomer}
                onChange={(e) => handleSelectChange(e, 'accountId')}
              />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={statusOptions}
                isSearchable={true}
                isClearable={true}
                placeholder={'Select Status...'}
                onChange={(e) => handleSelectChange(e, 'status')}
                value={selectedStatus}
                required
              />
            </Col>

          </Row>


          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />

          {viewModal &&
            <ViewModal
              showModal={showViewModal}
              toggleModal={viewModal}
              journalVoucher={idRow}
            />
          }

        </div>
      }


    </div>
  )
}

export default JvReport;
